export const FORM_DEFAULT_VALUE = {
  imgUrls: [],
  tagIds: [],
  buyerId: '',
  buyerName: '',
  content: '',
  createDate: '',
  orderItemId: '',
  productId: '',
  rate: '',
  reviewId: '',
  status: '',
  userId: '',
};

export const REVIEW_FORM_TAB_KEY = {
  REVIEW: 0,
  TAG_LIST: 1,
};

export const TAG_TABLE_INITIAL_OPTION = {
  name: null,
  id: null,
  sort: {
    id: '-id',
  },
  page: 0,
  pageSize: 20,
};
